/**
 * uiActionBridge — the imperative PLAYER-ACTION channel for engine-mounted
 * windows. The action analog of `windowBridge.toggle`.
 *
 * The unified window engine mounts propless gameplay-window Content as SIBLINGS
 * of <Game/> (under WindowHost), so they are OUTSIDE the prop tree that used to
 * thread `onAction={actionDispatcher.dispatch}` down from Game.tsx. Rather than
 * re-thread props (impossible for engine-mounted content) or duplicate
 * ActionDispatcher's routing, those windows call `uiActionBridge.dispatch(...)`,
 * which Game.tsx wires to the one canonical `ActionDispatcher.dispatch` on mount
 * (mirror of how WindowManagerProvider wires `windowBridge.toggle`).
 *
 * Before Game mounts it's a no-op; by interaction time (a user clicking a
 * stat-allocate / use-item button) Game has long since wired it. Same lifecycle
 * guarantee windowBridge relies on.
 */
export const uiActionBridge: { dispatch: (action: string, data?: unknown) => void } = {
  dispatch: () => {},
};
